export const ATTENDANCE_STATES = {
  WAITING_ATTENDANCE: 'AGUARDANDO_ATENDIMENTO',
  ATTENDANCE_STARTED: 'ATENDIMENTO_INICIADO',
  CALL_STARTED: 'CHAMADA_INICIADA',
  CALL_RESTARTED: 'CHAMADA_REINICIADA',
  CALL_ENDED: 'CHAMADA_ENCERRADA',
  ATTENDANCE_CANCELLED_MEDIC: 'ATENDIMENTO_CANCELADO_PELO_MEDICO',
  ATTENDANCE_CANCELLED_TIME: 'ATENDIMENTO_CANCELADO_POR_ATRASO',
  ATTENDANCE_END: 'ATENDIMENTO_CONCLUIDO',
  ATTENDANCE_CANCELLED_PATIENT_BLOCKED:
    'ATENDIMENTO_CANCELADO_PACIENTE_BLOQUEADO',
  CANCELLED_DUE_TO_AUTHORIZATION_FAILURE:
    'ATENDIMENTO_CANCELADO_POR_FALHA_AUTORIZACAO',
  UNAUTHORIZED_SERVICE: 'ATENDIMENTO_NAO_AUTORIZADO',
}
export const SCHEDULING_STATES = {
  ATTENDANCE_LATE: 'ATRASADO_MEDICO_NOTIFICADO',
  RESCHEDULED: 'REAGENDADO',
}

export const queueDataTranslate = {
  idProtocolo: 'id',
  status: 'status',
  idTipoProfissional: 'council',
  idEspecialidadeProfissional: 'professionalSpecialityId',
  tipoProfissional: 'councilString',
  npsRespondido: 'npsAnswered',
  pacienteOnline: 'patientOnline',
  posicaoFila: 'queuePosition',
  tamanhoFila: 'queueSize',
  tempoEstimado: 'estimatedTime',
  tempoEstimadoInicial: 'initialEstimatedTime',
  tempoMaximoEspera: 'maximumWaitTime',
  tempoMinimoEspera: 'minimumWaitTime',
  idProfissional: 'professionalId',
  nomeProfissional: 'professionalName',
  fotoProfissional: 'professionalPhoto',
  especialidadeProfissional: 'professionalSpeciality',
  sexoProfissional: 'professionalSex',
  anexos: 'attachments',
  dataHoraAgendada: 'scheduledDate',
  dataHoraTerminoAtendimento: 'endScheduledDate',
  statusAgendamento: 'scheduledStatus',
  atendimentoPsicologiaViva: 'psyAliveAttendance',
  idAtendimento: 'attendanceId',
  metodoPagamento: 'paymentMethod',
  consultaConfirmada: 'isConsultationConfirmed',
  tokenAtendimento: 'attendanceToken',
  acessouHistoricoPaciente: 'medicAccessedHistory',
  flagProfissionalTriagista: 'isScreeningProfessional',
  contagemAvisosAoProfissionalSalaEspera: 'professionalWarningCount',
}

export const callDataTranslate = {
  idAtendimento: 'attendanceId',
  idChamada: 'callId',
  idEspecialidade: 'specialityId',
  idProfissional: 'professionalId',
  nomeEspecialidade: 'speciality',
  nomeProfissional: 'professionalName',
  sexo: 'sex',
  statusFila: 'queueStatus',
  tipoMeeting: 'meetingType',
  tokenAtendimento: 'attendanceToken',
  tokenChamada: 'callToken',
  urlFoto: 'photo',
  statusAgendamento: 'scheduledStatus',
  zoomMeetingId: 'zoomMeetingId',
  zoomMeetingPasswd: 'zoomMeetingPass',
  zoomMeetingUrl: 'zoomMeetingUrl',
}

export const END_CONSULTATION_STATES = [
  ATTENDANCE_STATES.ATTENDANCE_END,
  ATTENDANCE_STATES.ATTENDANCE_CANCELLED_MEDIC,
  ATTENDANCE_STATES.ATTENDANCE_CANCELLED_TIME,
  ATTENDANCE_STATES.CALL_ENDED,
]
